/**
 * Controler eServices.php
 */

var localisationWindow = null;

require(
        ['smartmenus.bootstrap', 'bootstrap',
            'es6-shim', 'EventSource'],
        function () {
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);


require(["commonController"], function () {});


function initializeCtrl()
{
    require(
            ['jquery', 'moment', 'resizeScreen', 'requiredField',
                'checkFeatures',
                'Seed', 'Seed.Menu'
            ],
            function ($, moment, resizeScreen, requiredField, checkFeatures, Seed) {
                "use strict";

                try {
                    var cultureMoment = localeMoment;//culture.toLowerCase();
                    moment.locale(cultureMoment);
                } catch (err) {
                    cultureMoment = cultureMoment.split("-");
                    cultureMoment = cultureMoment[0];
                    moment.locale(cultureMoment);
                }

                $(window).resize(function () {
                    waitForFinalEvent(
                            resizeScreen.onWindowResize,
                            150,
                            "some unique string"
                            );
                });
                $(window).bind('beforeunload', requiredField.onBeforeUnload);
                Seed.Menu.ShowModule("accueil");

                if (moduleType === "ServiceMaint") {
                    initHome();
                }

                $('#bench').html('<?= $benchTXT; ?>');
            },
            function (err) {
                console.error("ERROR: ", err.requireType);
                console.error("MODULES: ", err.requireModules);
            }
    );
}

/**
 * Callback to manage timer
 * @type Function Callback
 */
var waitForFinalEvent = (function () {
    "use strict";
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            require(['lib'], function (lib) {
                uniqueId = lib.uniqid();
            });
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

function showModule(nomModule, libModule, numAction, isDebug, isDefaultAction)
{
    "use strict";
    require(
            ["jquery", "requiredField", "processLauncher",
                "Seed", "Seed.Menu", "Seed.Tab"],
            function ($, requiredField, processLauncher, Seed) {
                if (!requiredField.checkRequiredFieldInCurrentModule(
                        Seed.Tab.CurrentModule,
                        Seed.Tab.aActive[Seed.Tab.CurrentModule]
                        )) {
                    return false;
                }
                Seed.Menu.ShowModule(nomModule, libModule, isDefaultAction);
                if (isDefaultAction !== true && numAction) {
                    processLauncher.process(
                            numAction,
                            null,
                            null,
                            null,
                            isDebug
                            );
                }
                if (moduleType === "ServiceMaint" && nomModule === "accueil") {
                    initHome();
                }
                if (isDefaultAction === true
                        && Seed.Tab.aModule.indexOf(nomModule) === -1) {
                    processLauncher.process(
                            numAction,
                            null,
                            null,
                            null,
                            isDebug
                            );
                }
            }
    );
}

/**
 * Deconnection d'un utilisateur
 * @param pUser Cle de l'utilisateur
 */
function disconnect(pUser)
{
    "use strict";
    require(
            ["requiredField", 'Seed', "Seed.Ajax"],
            function (requiredField, Seed) {
                if (!requiredField.checkRequiredFieldInCurrentModule(
                        Seed.Tab.CurrentModule,
                        Seed.Tab.aActive[Seed.Tab.CurrentModule]
                        )) {
                    return false;
                }

                if (moduleType === "ServiceMaint") {
                    if (localisationWindow && !localisationWindow.closed) {
                        localisationWindow.close();
                    }
                    Seed.Ajax.Post({
                        url: "php_bdd/disconnect.php",
                        data: "user=" + pUser,
                        async: false
                    });
                } else if (moduleType === "ePortail") {
                    Seed.Ajax.Post({
                        url: "template/disconnect.php",
                        data: "user=" + pUser,
                        async: false
                    });
                }

                window.location = "../";
            }
    );
}

//****** Lancement action via ProcessLauncher
function Process(
        numaction,
        param,
        paramui,
        input,
        modeDebug,
        forceNoReload,
        forceNoRead,
        isImpr,
        selectedElem,
        isFromForm,
        event
        ) {

    "use strict";
    require(["processLauncher"], function (processLauncher) {
        processLauncher.process(
                numaction,
                param,
                paramui,
                input,
                modeDebug,
                forceNoReload,
                forceNoRead,
                isImpr,
                selectedElem,
                isFromForm,
                event
                );
    });
}

function ProcessUpdate(
        pNomTable,
        pIndex,
        pNomChamp,
        pNouvelleValeur,
        pImport,
        forceReload,
        origine,
        typechamp
        ) {

    "use strict";
    require(["processLauncher"], function (processLauncher) {
        processLauncher.processUpdate(
                pNomTable,
                pIndex,
                pNomChamp,
                pNouvelleValeur,
                pImport,
                forceReload,
                origine,
                typechamp
                );
    });
}

function ProcessAction(sendrequest, input, forceNoReload, forceNoRead)
{
    "use strict";
    require(["processLauncher"], function (processLauncher) {
        processLauncher.processAction(
                sendrequest,
                input,
                forceNoReload,
                forceNoRead
                );
    });
}

function ProcessPHP(URL, param, paramui, type, titre)
{
    "use strict";
    require(["processLauncher"], function (processLauncher) {
        processLauncher.processPHP(
                URL,
                param,
                paramui,
                type,
                titre
                );
    });
}

function initializeAlert()
{
    "use strict";
    require(
            ['jquery', "EventSource"],
            function ($) {
                // Alertes
                if (typeof (EventSource) !== "undefined") {
                    // Yes! Server-sent events support!
                    // Some code.....
                    var source = new EventSource(
                            "_module/Alerte/demo_sse.php?"
                            + "moduleType=" + moduleType
                            );

                    source.addEventListener('message', function (e) {
                        var myObject = JSON.parse(e.data);
                        for (var key in myObject) {
                            var value = myObject[key];
                            var module = $('#tdmainmenu')
                                    .find('li[id^=' + key + '_alert]')
                                    .find('span.label');
                            $(module).text(value);
                        }
                    }, false);
                } else {
                    // Sorry! No server-sent events support..
                    console.log("Sorry! No server-sent events support..");
                }
            },
            function (err) {
                console.error("ERROR: ", err.requireType);
                console.error("MODULES: ", err.requireModules);
            }
    );
}

function envoiMail(param, fromJS)
{
    require(
            ["jquery", "parameter", "Seed", "Seed.Ajax"],
            function ($, parameter, Seed) {
                if (!param) {
                    param = [];
                }
                if (!fromJS) {
                    param = JSON.parse(param);
                }
                // etat
                var etat = $('#etatImpression').val();
                param["nometat"] = etat;
                // email
                var email = $('#mailDestinataire').val();
                param["destinataire"] = email;
                if (param['fromuser']) {
                    param['fromuser'] = true;
                } else {
                    param['fromuser'] = false;
                }

                if (param) {
                    if (typeof param !== 'object') {
                        var paramLength = param.length;
                        for (var i = 0; i < paramLength; i++) {
                            param[i][1] = parameter.decodeParam(param[i][1]);
                            param[i][1] = encodeURIComponent(param[i][1]);
                        }
                    }
                }

                Seed.Ajax.Post({
                    url: 'php_spec/envoimail.php',
                    data: param,
                    async: true,
                    success: function (response) {
                        var pTarget = $('#mailDestinataire').parents('#modalIframe')[0];
                        var jscript = document.createElement("SCRIPT"); // BALISE SCRIPT
                        jscript.text = response;
                        pTarget.appendChild(jscript); // AJOUT DU SCRIPT AU DOCUMENT
                    }
                });
            }
    );
}

//********* PanelController ? *****



function initializePHPForm(nomtab, page, sImport)
{
    "use strict";
    require(
            ["Seed", "Seed.Tab", "Seed.Page"],
            function (Seed) {
                if (nomtab) {
                    Seed.Tab.AddTab();
                    Seed.Tab.SetText(nomtab);
                    Seed.Page.Load(page, sImport, true);
                    Seed.Tab.SetCallback(function callb()
                    {
                        Seed.Page.Load(page, sImport, true);
                    });
                } else {
                    Seed.Page.Load(page, sImport, false);
                }
            }
    );
}

// Interface
function showInterface(nomListe, label)
{
    "use strict";
    require(
            ["resizeScreen", "Seed", "Seed.Interface", "Seed.Tab"],
            function (resizeScreen, Seed) {
                Seed.Interface.Init(nomListe);
                Seed.Tab.SetText(label);
                resizeScreen.resizeScreen();
            }
    );
}

// Import
function initializeImport(label)
{
    "use strict";
    require(
            ["Seed",
                "Seed.Import", "Seed.Tab",
                "jquery.uniform", "jquery-form", "jquery-ui"],
            function (Seed) {
                Seed.Tab.SetText(label);
            }
    );
}

function openLocalisation(arg) {
    if (typeof arg !== "undefined") {
        arg = '?origin=' + arg;
        
    }
    var url = "../source/_module/Geoloc/index.php" + arg;
    var target = "Localisation";
    showModule();
    var isChrome = ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) && (navigator.vendor.toLowerCase().indexOf("google") > -1));
    if (isChrome) {
        if (localisationWindow && !localisationWindow.closed) {
            localisationWindow.focus();
        } else {
            localisationWindow = open(url, target);
        }
    } else {
        if (localisationWindow && !localisationWindow.closed) {
            localisationWindow.close();
        }
        localisationWindow = open(url, target);
        return false;
    }
};
define("eservicesController", function(){});

